export enum CheckpointStatusType {
    Ok = 1,
    NotOk = 2,
}

export enum FiCheckPointAnswerHistoryType {
    Unknown = 0,
    ToOk = 1,
    ToNotOk = 2,
    FromOkToNotOk = 3,
    FromNotOkToOk = 4,
    FromOkToNull = 5,
    FromNotOkToNull = 6,
}

export enum FiChecklistSectionTypes {
    General,
    Settings,
    Checkpoints,
    ComplianceThreshold,
    //Preview,
    //Schedules,
    QRCodes,
}
